import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { tagsActions } from '@src/store/reducers/tagTypesReducer';

import * as _ from 'lodash';

@Component({
    selector: 'tag-type-item',
    template: require('./tag-type-item.component.html'),
    styles: [require('./tag-type-item.component.scss')]
})
export class TagTypeItemComponent {
    @Input() public set tagTypeItem(value: any) {
        this._tempTagTypeItem = this.deepCopy(value) || {};
        this._tagTypeItem = value || {};
    }

    public get tagTypeItem() {
        return this._tagTypeItem;
    }

    @Input() public hasItems: any;

    @Output() public resetTagType = new EventEmitter<any>();
    @Output() public onDelete = new EventEmitter<any>();

    private _tempTagTypeItem: any;
    private _tagTypeItem: any;
    private unSubscribe: any;

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService,
        private translatePipe: TranslatePipe) {
    }

    public async save() {
        if (!this._tagTypeItem || !this._tagTypeItem.name) {
            const translations = await this.translatePipe.transform(['ERROR', 'ERROR_FIELD_RQUEIRED']);
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: `Tag Type Name ${translations['ERROR_FIELD_RQUEIRED']}`
            });
        } else {
            if (this._tagTypeItem.isNew) {
                this.unSubscribe = this.store.subscribe(() => {
                    const tagTypesState = this.store.getState().tagTypes;
                    if (tagTypesState.tagTypes) {
                        delete this._tagTypeItem.isNew;
                        const newTagType = tagTypesState.tagTypes[0];
                        this._tagTypeItem.id = newTagType.id;
                        this.unSubscribe();
                    }
                });

                this.store.dispatch({
                    type: tagsActions.CREATE_TAG_TYPE,
                    payload: { tagType: this._tagTypeItem }
                }).catch(() => { this.cancel(); });
            } else {
                this.store.dispatch({
                    type: tagsActions.UPDATE_TAG_TYPE,
                    payload: { tagType: this._tagTypeItem }
                }).catch(() => { this.cancel(); });
            }
        }
    }

    public cancel() {
        this.resetTagType.emit(this._tempTagTypeItem);
    }

    private deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return _.cloneDeep(obj);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/tag-types-manager/tag-type-item/tag-type-item.component.ts